import React from "react";

export const Footer = () => {
  return (
    <footer>
      <div className="footer__wrapper">
        <h4>
          Powered by <span>clean</span> data & grit
        </h4>
      </div>
    </footer>
  );
};
